import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(theme => ({
  inputNumberContainer: {
    display: 'flex',
  },
  button: {
    width: 36,
    height: 36,
    fontWeight: 900,
    fontSize: theme.fonts.sizes.font18PX,
    color: theme.colors.dark.darkSlateGray,
    backgroundColor: theme.colors.orange.orange,
    border: `1px solid ${theme.colors.orange.orange}`,
    transition: 'all .3s ease',
    '&:focus': {
      outline: 0,
    },
    '&:hover': {
      outline: 0,
    },
  },
  decrementButton: {
    borderRadius: '6px 0 0 6px',
  },
  incrementButton: {
    borderRadius: '0 6px 6px 0',
  },
  quantity: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 36,
    height: 36,
    margin: '0 4px',
    fontWeight: 700,
    textAlign: 'center',
    fontSize: theme.fonts.sizes.font16PX,
    color: theme.colors.orange.orange,
    backgroundColor: theme.colors.dark.darkBlue,
  },
  pressedButton: {
    backgroundColor: theme.colors.orange.darkOrange,
    borderColor: theme.colors.orange.darkOrange,
  },
}));
